import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

export default class OrderService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/order'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/order', payload),
      // edit: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/order/${id}`),
      get: (id) => axios.get(APIConfig.BPIURL + `/order/${id}`),

      // 編輯訂單資訊 備註、發票類型 等等
      updateInfo: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/info`, payload),
      // 物流資訊
      updateLogisticsInfo: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/logistics-info`, payload),
      // 編輯收件人
      updateReceiver: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/receiver`, payload),
      // 編輯寄件人
      updateSender: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/sender`, payload),
      // 編輯訂單狀態
      updatOrderStatus: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/order-status`, payload),
      // 編輯出貨狀態
      updateLogisticsStatus: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/logistics-status`, payload),
      // 編輯付款狀態
      updatePaymentStatus: (id, payload) => axios.put(APIConfig.BPIURL + `/order/${id}/payment-status`, payload),
      // 包含更多資訊
      getOrderListWithDetail: (ids) => axios.get(APIConfig.BPIURL + '/order-list-with-detail?ids=' + JSON.stringify(ids))
    }

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    return new Promise((resolve, reject) => {
      reject(Error('此API禁用'))
    })
    // vm.isLoading = true
    // return this.apis.edit(payload.ID, payload)
    //   .then(res => {
    //     let ok = res && res.data && res.data.status === 'ok'
    //     if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
    //     return res
    //   })
    //   .finally(() => {
    //     vm.isLoading = false
    //   })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  get (vm, id) {
    vm.isLoading = true
    return this.apis.get(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateInfo (vm, payload) {
    vm.isLoading = true
    let id = payload.ID
    return this.apis.updateInfo(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateLogisticsInfo (vm, payload) {
    vm.isLoading = true
    let id = payload.ID
    return this.apis.updateLogisticsInfo(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateReceiver (vm, id, payload) {
    vm.isLoading = true
    return this.apis.updateReceiver(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateSender (vm, id, payload) {
    vm.isLoading = true
    return this.apis.updateSender(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updatOrderStatus (vm, id, payload) {
    vm.isLoading = true
    return this.apis.updatOrderStatus(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateLogisticsStatus (vm, id, payload) {
    vm.isLoading = true
    return this.apis.updateLogisticsStatus(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updatePaymentStatus (vm, id, payload) {
    vm.isLoading = true
    return this.apis.updatePaymentStatus(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  // custom
  getOrderListWithDetail (vm, ids) {
    vm.isLoading = true
    return this.apis.getOrderListWithDetail(ids)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
